import { create } from '@thoughtspot/logger';
import { getChartType } from '../../../../utils/common-util';
const logger = create('chart-to-ts > native-chart-events');
const HTTP_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};
const SSE_HTTP_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'text/event-stream',
};
const HTTP_METHODS = {
    POST: 'POST',
};
const MUZE_STUDIO_CODEGEN_API_PATH = '/muze-studio/codegen/query';
const MUZE_AI_PROMPT_TO_CODE_API_PATH = '/muze-ai/api/prompt-to-code';
function parseSSELine(line, onChunk) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith(':') || !trimmed.startsWith('data:')) {
        return null;
    }
    const dataStr = trimmed.slice(5).trim();
    if (dataStr === '[DONE]')
        return null;
    try {
        const parsed = JSON.parse(dataStr);
        onChunk(parsed);
        return parsed;
    }
    catch {
        return null;
    }
}
async function consumePromptToCodeSSE(reader, onChunk) {
    const decoder = new TextDecoder();
    let buffer = '';
    let doneData = null;
    while (true) {
        const { done, value } = await reader.read();
        if (done)
            break;
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';
        lines.forEach((line) => {
            const parsed = parseSSELine(line, onChunk);
            if (parsed?.type === 'done' && parsed.data) {
                doneData = parsed.data;
            }
        });
    }
    if (buffer.trim()) {
        const parsed = parseSSELine(buffer, onChunk);
        if (parsed?.type === 'done' && parsed.data) {
            doneData = parsed.data;
        }
    }
    reader.releaseLock();
    return doneData;
}
async function executePromptToCode(body, onChunk) {
    const response = await fetch(`${window.location.origin}${MUZE_AI_PROMPT_TO_CODE_API_PATH}`, {
        method: HTTP_METHODS.POST,
        headers: SSE_HTTP_HEADERS,
        credentials: 'include',
        body,
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const reader = response.body?.getReader();
    if (!reader) {
        throw new Error('Response has no readable stream body');
    }
    const doneData = await consumePromptToCodeSSE(reader, onChunk);
    if (!doneData) {
        throw new Error('SSE stream completed without a done payload');
    }
    return {
        isValid: true,
        data: doneData,
    };
}
export const getMuzeStudioCodegenEventProcessor = (props) => {
    const { chartModel, onStreamChunk } = props;
    const chartType = getChartType(chartModel);
    return {
        validateEventPayload: (eventData) => {
            logger.info('validateEventPayload', { eventData, chartType });
            if (!eventData?.payload?.body) {
                return {
                    isValid: false,
                    errors: ['eventData.payload.body is required in payload'],
                };
            }
            try {
                JSON.parse(eventData.payload.body);
            }
            catch (error) {
                return {
                    isValid: false,
                    errors: ['Payload body must be valid JSON'],
                };
            }
            return { isValid: true };
        },
        executeEvent: async (eventData) => {
            try {
                const isPromptToCode = eventData.payload.apiType === 'prompt-to-code';
                if (isPromptToCode) {
                    const { streamId } = eventData.payload;
                    const onChunk = streamId && onStreamChunk
                        ? (chunk) => onStreamChunk(streamId, chunk)
                        : () => undefined;
                    return await executePromptToCode(eventData.payload.body, onChunk);
                }
                const response = await fetch(`${window.location.origin}${MUZE_STUDIO_CODEGEN_API_PATH}`, {
                    method: HTTP_METHODS.POST,
                    headers: HTTP_HEADERS,
                    credentials: 'include',
                    body: eventData.payload.body,
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return {
                    isValid: true,
                    data: await response.json(),
                };
            }
            catch (error) {
                logger.warn('Error fetching data:', error);
                return {
                    isValid: false,
                    errors: [
                        error instanceof Error
                            ? error.message
                            : 'Unknown error occurred',
                    ],
                };
            }
        },
    };
};
//# sourceMappingURL=index.js.map